import React from 'react'
import Header from '../Layout/Login/Header'
import Main from '../Layout/Login/Main'
import Footer from '../Layout/Login/Footer'

function LoginScreen() {

    return (

        <>
        
            <Header/>

            <Main/>

            <Footer/>

        </>

    )

}

export default LoginScreen